import axios from "axios";
import config from "../constants/config";

export default {
  methods: {
    async ChangePassword (body) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.CHANGE_PASSWORD}`,
        body
      );

      return res.data;
    },
    async GetLocationDetails () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.GET_LOCATION}`
      );

      return res.data;
    },
    async SaveLocationDetails (details) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.SAVE_LOCATION}`,
        details
      );

      return res.data;
    },
    async GetAllPackages () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.GET_PACKAGES}`
      );

      return res.data;
    },
    async CreateNewPackage (pkg) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.CREATE_PACKAGE}`,
        pkg
      );

      return res.data;
    },
    async SavePackage (pkg) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.SAVE_PACKAGE}`,
        pkg
      );

      return res.data;
    },
    async GetAllUsers () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.GET_USERS}`
      );

      return res.data;
    },
    async GetRPOUsers () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.GET_RPO_USERS}`
      );

      return res.data;
    },
    async GetRoles () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.GET_ROLES}`
      );

      return res.data;
    },
    async CreateNewUser (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.CREATE_USER}`,
        payload
      );

      return res.data;
    },
    async CreateRPOUser (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.CREATE_RPO_USER}`,
        payload
      );

      return res.data;
    },

    async CreateService (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.CREATE_EMERGENCY_SERVICE}`,
        payload
      );

      return res.data;
    },

    async GetEmergencyServices () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.EMERGENCY_SERVICE}`
      );
      return res.data;
    },

    async UpdateEmergencyServices (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.UPDATE_EMERGENCY_SERVICE}`,
        payload
      );

      return res.data;
    },

    async SaveRPODevices (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.SAVE_RPO_DEVICES}`,
        payload
      );

      return res.data;
    },
    async UpdateUser (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.UPDATE_USER}`,
        payload
      );

      return res.data;
    },
    async CreateNewCompany (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.CREATE_COMPANY}`,
        payload
      );

      return res.data;
    },
    async GetAllCompanies () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.GET_COMPANIES}`
      );

      return res.data;
    },
    async GetCompanyTypes () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.GET_COMPANY_TYPES}`
      );

      return res.data;
    },
    async UpdateCompany (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.UPDATE_COMPANY}`,
        payload
      );

      return res.data;
    },
    async GetDeviceTypes () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.GET_DEVICE_TYPES}`
      );

      return res.data;
    },
    async AddNewDevice (device) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.ADD_DEVICE}`,
        device
      );

      return res.data;
    },
    async UpdateDevice (device) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.UPDATE_DEVICE}`,
        device
      );

      return res.data;
    },
    async DeleteDevice (id) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.DELETE_DEVICE}`,
        id
      );

      return res.data;
    },
    async ConnectZabbix (details) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.CONNECT_ZABBIX}`,
        details
      );

      return res.data;
    },
    async VerifyZabbixConnection (details) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.VERIFY_ZABBIX}`,
        details
      );

      return res.data;
    },
    async ImportGroupAndDevices (groupDetails) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.IMPORT_ZABBIX_DEVICES}`,
        groupDetails
      );

      return res.data;
    },

    async CreateVsds (vsdsData) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.CREATE_VSDS}`,
        vsdsData
      );
      return res.data;
    },

    async CreateAPI (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.CREATE_API}`,
        payload
      );
      return res.data;
    },

    async GetAPI () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.GET_API}`
      );
      return res.data;
    },

    async UpdateAPI (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.UPDATE_API}`,
        payload
      );
    },

    async DeleteAPI (id) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.DELETE_API}`,
        id
      );
    },

    async ShowVsds () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.SHOW_VSDS}`
      );
      return res.data;
    },

    async UpdateVsds (data) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.UPDATE_VSDS}`,
        data
      );
    },

    async DeleteVsds (id) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.DELETE_VSDS}`,
        id
      );
    },

    async CreateMQTTConnection (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.CREATE_MQTT}`,
        payload
      );
      return res.data;
    },

    async GetMQTTConnection () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.GET_MQTT}`
      );
      return res.data;
    },

    async UpdateMQTTConnection (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.UPDATE_MQTT}`,
        payload
      );
    },

    async DeleteMQTTConnection (id) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.DELETE_MQTT}`,
        id
      );
    },

    async GetSpeedRules () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.SPEED_RULES}`
      );
      return res.data;
    },

    async SaveSpeedRule (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.SPEED_RULES}`,
        payload
      );
      return res.data;
    },

    async DeleteSpeedRule (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.DELETE_SPEED_RULE}`,
        payload
      );
      return res.data;
    },

    async GetNMSAccounts () {
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.NMS_ACCOUNTS}`
      );
      return res.data;
    },

    async SaveNMSAccount (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.NMS_ACCOUNTS}`,
        payload
      );
      return res.data;
    },

    async DeleteNMSAccount (payload) {
      const res = await axios.post(
        `${config.BASE_URL}${config.API_ROUTES.ADMINISTRATION.DELETE_NMS_ACCOUNT}`,
        payload
      );
      return res.data;
    },
  },
};
